import { render, staticRenderFns } from "./RiskCheck.vue?vue&type=template&id=8fa01a1a"
import script from "./RiskCheck.vue?vue&type=script&lang=js"
export * from "./RiskCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports